// Copyright (c) StrangeBee 2023

import { Route as AlertsDetailsRoute } from './Description';
import {
    Route as AlertsObservablesDetailsRoute,
    RouteWithReport as AlertsObservablesDetailsReportRoute,
} from './Observables/Details';
import { Route as AlertsObservablesListRoute } from './Observables/List';
import { Route as AlertTTPs } from './TTP/List';
import { Route as AttachmentListRoute } from './Attachments/List';
import { Route as AlertSimilarCases } from './SimilarCases/List';
import { Route as AlertSimilarAlerts } from './SimilarAlerts/List';
import { Route as AlertsRespondersListRoute } from './Responders/List';
import { Route as AlertHistory } from './History/List';

export default [
    AlertsDetailsRoute,

    AlertsObservablesDetailsReportRoute,
    AlertsObservablesDetailsRoute,
    AlertsObservablesListRoute,

    AlertTTPs,

    AttachmentListRoute,

    AlertSimilarCases,
    AlertSimilarAlerts,

    AlertsRespondersListRoute,

    AlertHistory,
];
